module.exports = __webpack_public_path__ + "img/LogoTelmex_Gris.25dfe177.png";